import React from "react";
import CardTitleImage from '../Card/CardTitleImage';
import Styles from './AboutUs_SA.module.scss';
import dr from '../../images/ImagesSA/AboutUs/dr.png';
import computer from '../../images/ImagesSA/AboutUs/computer.png';
import phone from '../../images/ImagesSA/AboutUs/phone.png';
import price from '../../images/ImagesSA/AboutUs/price.png';
import classnames from 'classnames';

interface AboutUsProps {
    classNameStyle: string
}

const AboutUs: React.FC<AboutUsProps> = (props: AboutUsProps) => {
    const { classNameStyle } = props;
  return (
      <div className="row">
           <CardTitleImage
                title="Cualquier dispositivo"
                content="Accede a una consulta médica en
                línea desde tu computadora, celular o tablet."
                classNameStyle={classnames(Styles.align, "col-lg-3")}
                image={<img src={computer} className="img-fluid" alt="Imagen computadora" />} />
            <CardTitleImage
                title="24/7"
                content="Puedes ingresar a nuestros servicios
                desde la comodidad de tu hogar en cualquier momento del día.​"
                classNameStyle={classnames(Styles.align, "col-lg-3")}
                image={<img src={phone} className="img-fluid" alt="Imagen teléfono" />} />
            <CardTitleImage
                title="Red de médicos"
                content="Contamos con una gran red de médicos generales y especialistas.​"
                classNameStyle={classnames(Styles.align, "col-lg-3")}
                image={<img src={dr} className="img-fluid" alt="Imagen médico" />} />
            <CardTitleImage
                title="A mejor precio"
                content="Paga un fee por cada cita con copago."
                classNameStyle={classnames(Styles.align, "col-lg-3")}
                image={<img src={price} className="img-fluid" alt="Imagen precio" />} />
       </div >
  );
};

export default AboutUs;